import { render, staticRenderFns } from "./AccountPreferences.vue?vue&type=template&id=115e18d0"
import script from "./AccountPreferences.vue?vue&type=script&lang=js"
export * from "./AccountPreferences.vue?vue&type=script&lang=js"
import style0 from "./AccountPreferences.vue?vue&type=style&index=0&id=115e18d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports